import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../../../common/theme/ISpcTheme';

export type VehicleIdentificationNumberStylesClasses = 'container' | 'value';

const vehicleIdentificationNumberStyles = makeStyles<ISpcTheme, VehicleIdentificationNumberStylesClasses>(
  ({ breakpoints, typography }) => ({
    container: {
      display: 'flex',
      alignItems: 'center',
    },
    value: {
      [breakpoints.down('xs')]: {
        fontSize: typography.fontSM,
      },
    },
  }),
  { name: 'Customise_SummaryVin' },
);

export default vehicleIdentificationNumberStyles;
